import flatpickr from "flatpickr"
import "flatpickr/dist/l10n/ja"
flatpickr.l10ns.ja.firstDayOfWeek = 0

export { flatpickr }

export const datepickrOptions = {
  allowInput: true,
  dateFormat: 'Y-m-d',
  locale: 'ja',
  maxDate: '9999-12-31',
  minDate: '1873-01-01',
}

export const timepickrOptions = {
  allowInput: true,
  enableTime: true,
  noCalendar: true,
  time_24hr: true,
  dateFormat: 'H:i',
  locale: 'ja',
  minuteIncrement: 30,
}

export const datetimepickerOptions = {
  ...datepickrOptions,
  enableTime: true,
  dateFormat: 'Y-m-d H:i',
  minuteIncrement: 1,
}

$(document).ready(function() {
  flatpickr('.flatpickr-date', datepickrOptions)

  flatpickr('.flatpickr-time', timepickrOptions)

  flatpickr('flatpickr-datetime', datetimepickerOptions)

  flatpickr('.flatpickr-datetime-from', {
    ...datetimepickerOptions,
    defaultHour: 0,
    defaultMinute: 0,
  })

  flatpickr('.flatpickr-datetime-to', {
    ...datetimepickerOptions,
    defaultHour: 23,
    defaultMinute: 59,
  })
})
